import React, { useState } from "react";
import { Star, Send } from "lucide-react";
import { Alert } from "./ui";
import { api, formatApiError } from "../lib/api";

export default function RatingForm({ bookingId, reviewType, onReviewed }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const labels = {
    WORKER: { title: "Beri Rating Pekerja", placeholder: "Bagaimana pengalaman Anda?" },
    CUSTOMER: { title: "Beri Rating Pelanggan", placeholder: "Bagaimana pelanggan ini?" },
    APP: { title: "Beri Rating Aplikasi", placeholder: "Bagaimana pengalaman Anda menggunakan Cariinjasa?" },
  };
  const info = labels[reviewType] || labels.WORKER;

  const handleSubmit = async () => {
    if (rating === 0) {
      setError("Pilih rating bintang");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await api.post("/api/reviews", {
        booking_id: bookingId,
        review_type: reviewType,
        rating,
        comment: comment || null,
      });
      setDone(true);
      if (onReviewed) onReviewed();
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="card p-6 border-success-200 bg-success-50">
        <div className="flex items-center gap-3">
          <Star className="h-6 w-6 text-success-600" />
          <div>
            <p className="font-bold text-success-700">Terima kasih!</p>
            <p className="text-sm text-success-600">Rating Anda sudah dikirim.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="card p-6 border-brand-200 bg-brand-50">
      <p className="font-bold text-brand-800 mb-3">{info.title}</p>

      {error && <div className="mb-3"><Alert kind="error">{error}</Alert></div>}

      {/* Star Rating */}
      <div className="flex items-center gap-1 mb-4">
        {[1, 2, 3, 4, 5].map((star) => (
          <button
            key={star}
            type="button"
            onClick={() => setRating(star)}
            onMouseEnter={() => setHover(star)}
            onMouseLeave={() => setHover(0)}
            className="focus:outline-none"
            data-testid={`rating-star-${star}`}
          >
            <Star
              className={`h-8 w-8 transition-colors ${
                star <= (hover || rating)
                  ? "text-amber-400 fill-amber-400"
                  : "text-brand-200"
              }`}
            />
          </button>
        ))}
        {rating > 0 && (
          <span className="ml-2 text-sm font-medium text-brand-600">
            {rating === 1 ? "Sangat Kurang" : rating === 2 ? "Kurang" : rating === 3 ? "Cukup" : rating === 4 ? "Bagus" : "Sangat Bagus"}
          </span>
        )}
      </div>

      {/* Comment */}
      <textarea
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder={info.placeholder}
        rows={3}
        className="w-full rounded-xl border-2 border-brand-100 px-3 py-2.5 text-sm focus:border-brand-500 focus:outline-none resize-none bg-white mb-4"
        data-testid="rating-comment"
      />

      <button
        onClick={handleSubmit}
        disabled={loading || rating === 0}
        className="btn-primary w-full"
        data-testid="rating-submit"
      >
        {loading ? "Mengirim..." : <span className="flex items-center gap-2 justify-center"><Send className="h-4 w-4" /> Kirim Rating</span>}
      </button>
    </div>
  );
}
